import { useTranslation } from "react-i18next";
import PersonalPreferences from "./PersonalPreferences";

/** `/profile/preferences`: Personal preferences (F14, option A, PM-8) as option cards (F71), one of the person's own pages (F79). */
export default function PreferencesPage() {
  const { t } = useTranslation();
  return (
    <div className="app-card w-full max-w-2xl p-6 shadow-sm">
      <h1 className="app-title mb-4 text-xl font-semibold">{t("profile.pages.preferences")}</h1>
      <PersonalPreferences />
    </div>
  );
}
